/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link } from "react-router-dom";
class NavItemContainer extends Component {
  state = {
    active: this.props.pageCurrent === this.props.pageName,
  };

  setActive = () => {
    this.setState({
      active: true,
    });
  };

  onClickToggleSubmenu = () => {
    this.setState({
      active: !this.state.active,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.active && this.props.setActive && !this.updated) {
      this.updated = true;
      this.props.setActive();
    }

    if (prevProps.pageCurrent !== this.props.pageCurrent) {
      this.updated = false;
      this.setState({
        active: this.props.pageCurrent === this.props.pageName,
      });
    }
  }

  render() {
    if ((this.props.subItems || []).length > 0) {
      return (
        <li
          className={`sidenav-item has-subnav ${
            this.state.active ? "open" : ""
          }`}
        >
          <a style={{ cursor: "pointer" }} onClick={this.onClickToggleSubmenu}>
            <span className={`sidenav-icon icon ${this.props.icon}`}></span>
            <span className="sidenav-label">{this.props.text}</span>
          </a>
          <ul
            className="sidenav-subnav collapse"
            style={{ display: this.state.active ? "block" : "none" }}
          >
            {this.props.subItems.map((m, idx) => {
              return (
                <NavItemContainer
                  {...m}
                  key={idx}
                  pageCurrent={this.props.pageCurrent}
                  setActive={this.setActive}
                />
              );
            })}
          </ul>
        </li>
      );
    } else
      return (
        <li className={`sidenav-item ${this.state.active ? "active" : ""}`}>
          <Link to={this.props.path}>
            <span
              className={`sidenav-icon icon ${this.props.icon}`}
              style={{ display: this.props.icon ? "block" : "none" }}
            ></span>
            <span className="sidenav-label">{this.props.text}</span>
          </Link>
        </li>
      );
  }
}

export default NavItemContainer;
